import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=5d286c44"
import script from "./NotificationsView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports